import { useEffect } from 'react'
import { usePageView, loadAnalytics } from '@fs/zion-analytics'
import PropTypes from 'prop-types'

/**
 * Analytics provider component that handles analytics initialization and tracking
 * when analytics are enabled via query parameter
 */
const AnalyticsPageView = ({ pageDetail, pageChannel }) => {
  useEffect(() => {
    loadAnalytics()
  }, [])

  const pageViewData = {}
  if (pageDetail !== undefined) {
    pageViewData.page_detail = pageDetail
  }
  if (pageChannel !== undefined) {
    pageViewData.page_channel = pageChannel
  }

  usePageView(pageViewData)

  return null
}

AnalyticsPageView.propTypes = {
  pageDetail: PropTypes.string,
  pageChannel: PropTypes.string,
}

export default AnalyticsPageView
